import { render, staticRenderFns } from "./login.vue?vue&type=template&id=ae36d024"
import script from "./login.vue?vue&type=script&lang=ts"
export * from "./login.vue?vue&type=script&lang=ts"
import style0 from "./login.vue?vue&type=style&index=0&id=ae36d024&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports